// import React from 'react';
// import { Box, Typography, Link } from '@mui/material';

// const Announcements = () => (
//   <Box className="dashboard-card">
//     <Typography variant="h6">Announcements</Typography>
//     <Box sx={{ mt: 2 }}>
//     <Typography variant="body2" fontWeight="bold">
//       Coming soon.
//     </Typography>
//       {/* <Typography variant="body2" fontWeight="bold">
//         • Q3 Update <Link href="#">[Doc]</Link> <Link href="#">[Video]</Link>
//       </Typography>
//       <Typography variant="caption" color="textSecondary" display="block" sx={{ ml: 2 }}>
//         Investor call and video via Docsend.
//       </Typography> */}
//     </Box>
//   </Box>
// );

// export default Announcements;

import React, { useState } from "react";
import { Box, Typography, Chip, Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CampaignIcon from "@mui/icons-material/Campaign";

const DUMMY_ANNOUNCEMENTS = [
  {
    id: 1,
    title: "Q3 Fund Statements Available",
    body: "Your Q3 statements have been uploaded to the Document Vault. Please review at your convenience.",
    audience: "All Investors",
    date: "2d ago",
  },
  {
    id: 2,
    title: "Demo Fund 2 — Capital Call Notice",
    body: "A capital call has been issued for Demo Fund 2. Please check your dashboard for details.",
    audience: "Demo Fund 2",
    date: "5d ago",
  },
  {
    id: 3,
    title: "Platform Maintenance",
    body: "Scheduled maintenance this weekend, some features may be briefly unavailable.",
    audience: "All Investors",
    date: "1w ago",
  },
];

const Announcements = () => {
  const [selected, setSelected] = useState(null);

  return (
    <Box className="dashboard-card" sx={{ height: "100%" }}>
      <Typography variant="h6" fontWeight="bold" sx={{ mb: 1 }}>Announcements</Typography>

      {DUMMY_ANNOUNCEMENTS.map((a) => (
        <Box
          key={a.id}
          onClick={() => setSelected(a)}
          sx={{ cursor: "pointer", p: 1, mb: 1, borderRadius: 1, "&:hover": { bgcolor: "#f4f7f9" } }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <CampaignIcon sx={{ fontSize: "1rem", color: "#001529" }} />
            <Typography variant="body2" fontWeight="bold" noWrap>{a.title}</Typography>
          </Box>
          <Typography variant="caption" color="textSecondary" sx={{ display: "block", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
            {a.body}
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "space-between", mt: 0.5 }}>
            <Chip label={a.audience} size="small" sx={{ height: 18, fontSize: "0.65rem" }} />
            <Typography variant="caption" color="textSecondary">{a.date}</Typography>
          </Box>
        </Box>
      ))}

      <Dialog open={!!selected} onClose={() => setSelected(null)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          {selected?.title}
          <IconButton onClick={() => setSelected(null)}><CloseIcon /></IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 2 }}>{selected?.body}</Typography>
          <Chip label={selected?.audience} size="small" />
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default Announcements;